import { createAsyncThunk } from "@reduxjs/toolkit";
import { environment } from "../../environments";
import {
  GetPhoneCallRequest,
  GetPhoneCallResponse,
} from "../../models/PhoneCall.model";

const API_BASE_URL = environment.apiUrl;

export const getPhoneCalls = createAsyncThunk<
  GetPhoneCallResponse,
  GetPhoneCallRequest,
  { rejectValue: string }
>("phoneCall/getPhoneCalls", async (requestData, { rejectWithValue }) => {
  try {
    const response = await fetch(`${API_BASE_URL}PhoneCall/GetPhoneCalls`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(requestData),
    });

    if (!response.ok) throw new Error(`HTTP ${response.status}`);
    const data: GetPhoneCallResponse = await response.json();

    if (!data.success)
      return rejectWithValue(data.message || "Failed to get phone calls");

    return data;
  } catch (error) {
    return rejectWithValue(
      error instanceof Error ? error.message : "Unknown error",
    );
  }
});
